import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { injectIntl, FormattedMessage } from 'react-intl';
import { inject } from 'async';
import { Form } from 'react-bootstrap/lib/Navbar';
import SharedIntlProviderHOC from '../../shared-components/hocs/sharedIntlProviderHOC';

const ExternalCalendarSyncModalComponent = ({
  showModal,
  toggleModal,
  selectedSpace,
  ...props
}) => {
  const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();
  const handleLearnMoreClick = () => {
    window.open(`https://support.peerspace.com/hc/${zendeskLocale}/articles/360015812591-Can-I-sync-a-calendar-with-Peerspace-`, '_blank');
  };
  const modalBody = (
    <div className="row">
      <div className="col-xs-12 text-center">
        <h3 className="text-center no-margin">
          <FormattedMessage id="hosting.calendar_main.external_calendar_modal_heading" defaultMessage="Add external calendar" />
        </h3>
        <p className="text-center margin-lg-top margin-lg-bottom">{selectedSpace}</p>
        <button
          className="sync-modal-option flex space-between padding-lg margin-md-bottom btn-block text-left"
          onClick={()=>toggleModal('SyncFlow1')}
        >
          <div className="flex middle w-100 space-between">
            <div>
              <h6 className="no-margin">
                <FormattedMessage id="hosting.calendar_main.external_calendar_modal_sync" defaultMessage="Sync calendar" />
                &nbsp;
                <span className="badge badge-green">
                  <FormattedMessage id="hosting.calendar_main.external_calendar_modal_recommended" defaultMessage="Recommended" />
                </span>
              </h6>
              <p className="no-margin margin-md-top text-gray-dark">
                <FormattedMessage
                  id="hosting.calendar_main.external_calendar_modal_apps"
                  defaultMessage="Google, iCloud, Office 365, Exchange, and Outlook"
                />
              </p>
            </div>
            <img src="https://assets.peerspace.com/right-arrow.svg?v=rb" />
          </div>
        </button>
        <button
          className="sync-modal-option flex space-between padding-lg margin-md-bottom btn-block text-left"
          onClick={()=>toggleModal('ImportCalendarModal')}
        >
          <div className="flex middle w-100 space-between">
            <div>
              <h6 className="no-margin">
                <FormattedMessage
                  id="hosting.calendar_main.external_calendar_modal_ical"
                  defaultMessage="Import iCalendar (iCal) URL"
                />
              </h6>
              <p className="no-margin margin-md-top text-gray-dark">
                <FormattedMessage
                  id="hosting.calendar_main.external_calendar_modal_companies"
                  defaultMessage="Airbnb, VRBO, and other calendars"
                />
              </p>
            </div>
            <img src="https://assets.peerspace.com/right-arrow.svg?v=rb" />
          </div>
        </button>
        <a className="heavy"
          rel="noreferrer noopener"
          href={`https://support.peerspace.com/hc/${zendeskLocale}/articles/360015812591-Can-I-sync-a-calendar-with-Peerspace-`}
          target="_blank"
        >
          <FormattedMessage
            id="hosting.calendar_main.external_calendar_modal_link"
            defaultMessage="Learn more about calendar sync"
          />
        </a>
      </div>
    </div>
  );
  return (
    <BootstrapModal
      showModal={showModal}
      body={modalBody}
      toggleModal={toggleModal}
    />
  );
};

export const ExternalCalendarSyncModal = injectIntl(ExternalCalendarSyncModalComponent);

ExternalCalendarSyncModalComponent.propTypes = {
  selectedSpace: PropTypes.string,
  showModal: PropTypes.bool,
  toggleModal: PropTypes.func
};
